






















import { Component, Mixins, Vue } from 'vue-property-decorator'
import SummaryResultApis from '@/mixins/requests/branch/SummaryResultApis.vue'
import TabBase from '@/components/common/atoms/TabBase.vue'
import SubjectSummaryData from '@/views/branch/summaryResult/SubjectSummaryData.vue'
import WholeData from '@/views/branch/summaryResult/WholeData.vue'
import ByProblemTag from '@/views/branch/summaryResult/ByProblemTag.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import { StudyData } from '@/models/api/common/SummaryResultTypes.vue'
import { STUDY_MODE_CODE } from '@/constants/ApiConstant'

@Component({
  components: {
    TabBase,
    SubjectSummaryData,
    WholeData,
    ByProblemTag,
    ButtonBase,
  },
})
export default class SummaryResult extends Mixins(SummaryResultApis) {
  private tabBaseDatas: { id: number; name: string; component: string }[] = [
    { id: 1, name: '全体データ', component: 'WholeData' },
    { id: 2, name: '単元別データ', component: 'ByProblemTag' },
    { id: 3, name: '設問別データ', component: 'SubjectSummaryData' },
  ]

  private study: StudyData | null = null

  private get studyContentId(): string {
    return this.$route.params['studyContentId']
  }

  // タブ内のAPI結果や入力情報の保存領域
  private store = {}

  private activeTab = 1

  /** 授業モードがレコメンドモードか判定 */
  private get isStudyModeRecommend(): boolean {
    return !!(this.study && this.study.studyModeCode === STUDY_MODE_CODE['recommend'])
  }

  private async mounted() {
    Vue.prototype.$loading.start()
    try {
      this.study = await this.getStudy(this.studyContentId)
    } catch (e) {
      if (e.response.data.status === 400) {
        alert(e.response.data.message.message)
      } else {
        alert('エラーが発生しました')
      }
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private onClickBackButton() {
    // 受験者情報画面へ遷移
    this.$router.push({
      name: 'BranchStudentForStudy',
      params: { studyContentId: this.studyContentId },
    })
  }

  /** テスト結果集計タスク実行 */
  private async onClickExecStudySummaryTask(): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      await this.execStudySummaryTaskApi()
      alert('集計を開始しました。5～10分後に再度ご確認ください。')
    } catch (e) {
      if (e.response.data.status === 400) {
        alert(e.response.data.message)
      } else {
        alert('エラーが発生しました')
      }
    } finally {
      Vue.prototype.$loading.complete()
    }
  }
}
